import { Textarea as TextareaNextUI, TextAreaProps } from '@nextui-org/react';
import { cn } from '@nextui-org/theme';
import React from 'react';

import { Asterisk } from '@phosphor-icons/react';

const Textarea: React.FC<TextAreaProps> = ({ label, required, ...props }) => {
  const { classNames, ...rest } = props;
  const { inputWrapper, input, errorMessage } = classNames || {};

  return (
    <div>
      {label && (
        <div className='mb-[6px] flex gap-1'>
          <div className='text-primary font-medium text-sm'>{label}</div>
          {required && <Asterisk size={10} color='#D92D20' weight='bold' className='mt-[2px]' />}
        </div>
      )}
      <TextareaNextUI
        size='lg'
        radius='sm'
        variant='bordered'
        classNames={{
          inputWrapper: cn(
            'bg-white shadow-none border-1 border-borderPrimary',
            'hover:border-border-brand group-data-[focus=true]:border-border-brand',
            inputWrapper,
          ),
          input: cn(
            'placeholder:text-text-placeholder',
            input,
          ),
          errorMessage: cn(
            'text-text-error-primary',
            errorMessage,
          ),
        }}
        {...rest}
      />
    </div>
  );
};

export default Textarea;
